module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('h4', {
    staticClass: "inline"
  }, [_vm._v("TEAM")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md5": "",
      "offset-md2": ""
    }
  }, _vm._l((_vm.posts), function(post) {
    return _c('div', {
      key: post.title
    }, [_c('v-card', {
      staticClass: "my-3",
      attrs: {
        "hover": ""
      }
    }, [_c('v-card-media', {
      staticClass: "white--text",
      attrs: {
        "height": "190px",
        "src": post.imgUrl
      }
    }, [_c('v-container', {
      attrs: {
        "fill-height": "",
        "fluid": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "fill-height": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "align-end": "",
        "flexbox": ""
      }
    }, [_c('span', {
      staticClass: "headline inline-block"
    }, [_vm._v(_vm._s(post.title))])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_vm._v("\n          " + _vm._s(post.content) + "\n        ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      staticClass: "red--text",
      attrs: {
        "icon": "",
        "href": 'http://reddit.com/submit?url=' + post.more + '&title=' + post.title
      }
    }, [_c('icon', {
      attrs: {
        "name": "reddit-alien"
      }
    })], 1), _vm._v(" "), _c('v-btn', {
      staticClass: "light-blue--text",
      attrs: {
        "icon": "",
        "href": 'https://twitter.com/share?url=' + post.more + '&via=VidyasagarMSC&text=' + post.title
      }
    }, [_c('icon', {
      attrs: {
        "name": "twitter"
      }
    })], 1), _vm._v(" "), _c('v-btn', {
      staticClass: "blue--text text--darken-3",
      attrs: {
        "icon": "",
        "href": 'http://www.facebook.com/sharer.php?' + 'u=' + post.more + '&t=' + post.title
      }
    }, [_c('icon', {
      attrs: {
        "name": "facebook-f"
      }
    })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      staticClass: "orange--text",
      attrs: {
        "flat": "",
        "href": post.more,
        "target": "_blank"
      }
    }, [_vm._v("Read More")])], 1)], 1)], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52d48c32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Team.vue
// module id = 829
// module chunks = 1